import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import "whatwg-fetch"
import Sortable from "sortablejs"

Vue.directive("sortable", {
  inserted: function(el, binding) {
    new Sortable(el, binding.value || {})
  }
})

Vue.config.productionTip = false

router.beforeResolve((to, from, next) => {
  if (to.meta.isPublic) {
    next()
  } else {
    if (store.getters["user/loggedIn"]) {
      next()
    } else {
      next({ name: "root" })
    }
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app")
